import * as Immutable from 'immutable';
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import TemplateButton from './BoardTemplatePickerBodyListingTemplateButton';

import { getTemplateId } from '../boardTemplatePickerUtil';

import { sendAmplitudeEvent } from '../../../analytics/amplitudeService';

const EMPTY_LIST = Immutable.List();

const BoardTemplatePickerCategory = ({
    selectedTemplateId,
    navigation,
    templates,
    templateCollections,
    selectTemplate,
}) => {
    const selectedCollectionId = navigation.replace('category:', '');
    const selectedCollection = templateCollections.find((category) => category.get('id') === selectedCollectionId);

    const templatesInCollection = (selectedCollection && selectedCollection.get('templates')) || EMPTY_LIST;

    useEffect(
        () =>
            sendAmplitudeEvent({
                eventType: 'Viewed template picker category',
                eventProperties: {
                    category: selectedCollection && selectedCollection.get('title'),
                },
            }),
        [],
    );

    return (
        <div className="PickerBodyCategory picker-body scrollable">
            <ul className="picker-templates">
                {templatesInCollection.map((templateEntry) => (
                    <li key={getTemplateId(templateEntry)}>
                        <TemplateButton
                            templateEntry={templateEntry}
                            templates={templates}
                            selectedTemplateId={selectedTemplateId}
                            selectTemplate={selectTemplate}
                        />
                    </li>
                ))}
            </ul>
        </div>
    );
};

BoardTemplatePickerCategory.propTypes = {
    selectedTemplateId: PropTypes.string,
    navigation: PropTypes.string,
    templates: PropTypes.object,
    templateCollections: PropTypes.object,
    selectTemplate: PropTypes.func,
};

export default BoardTemplatePickerCategory;
